import {VariantUpdateEvent} from '@theme/events';
import {selectedVariant} from './kellermont-offer-model.js?v=standard-no-gifts-20261017';

export class KellermontVariantSelects extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;
    this.ready=true;
    this.product=JSON.parse(this.querySelector('[data-selector-product]').textContent);
    this.prices=JSON.parse(this.querySelector('[data-selector-prices]').textContent);
    this.scope=this.closest('.shopify-section') || this.parentElement;
    this.inputs=[...this.querySelectorAll('input[data-option-index]')];
    this.onPickerChange=event=>{
      if(!event.target.matches('input[data-option-index]'))return;
      const values=this.selectedValues();
      const variant=selectedVariant(this.product,values);
      const offer=this.scope.querySelector('kellermont-offer');
      const tier=offer?.active || offer?.querySelector('[data-offer-tier]:has(input[type=radio]:checked)');
      const rows=[...offer?.querySelectorAll('[data-variant-row]')||[]];
      // Original shared picker resets every item in both offer tiers.
      if(rows.length){
        this.syncing=true;
        for(const row of rows)for(const select of row.querySelectorAll('select[data-option-index]'))select.value=values[Number(select.dataset.optionIndex)];
        offer.render();
        this.syncing=false;
      }
      this.updateDisplay(variant,true,true);
    };
    this.onOfferChange=event=>{
      if(this.syncing||!event.target.closest('kellermont-offer'))return;
      const offer=event.target.closest('kellermont-offer');
      const tier=offer.active || offer.querySelector('[data-offer-tier]:has(input[type=radio]:checked)');
      const row=event.target.closest('[data-variant-row]');

      if(event.target.closest('[data-gift-options]'))return;
      this.syncFromOffer(true,row);
    };
    this.onPurchaseImage=event=>{
      const gallery=this.scope.querySelector('media-gallery');
      const {mediaId,gallery:eventGallery,hydrated}=event.detail||{};
      if(hydrated||!gallery||eventGallery&&eventGallery!==gallery||!mediaId)return;
      this.galleryRequest?.abort();
      const request=++this.galleryRequestNumber;
      if(gallery.querySelector('[slide-id="'+mediaId+'"],[data-media-id="'+mediaId+'"]')){gallery.removeAttribute('aria-busy');this.dataset.galleryStatus='ready';return;}
      const variant=this.product.variants.find(v=>String(v.featured_media?.id)===String(mediaId));
      if(variant)this.hydrateVariantGallery(variant,request);
    };
    this.galleryRequestNumber=0;
    document.addEventListener('purchase:image-update',this.onPurchaseImage);
    this.addEventListener('change',this.onPickerChange);
    this.scope.addEventListener('change',this.onOfferChange);
    // Read the current choice without selecting a media slide on initial load.
    this.updateDisplay(selectedVariant(this.product,this.selectedValues()),false,false);
    customElements.whenDefined('kellermont-offer').then(()=>{if(this.isConnected)this.syncFromOffer(false);});
  }
  disconnectedCallback(){this.galleryRequest?.abort();document.removeEventListener('purchase:image-update',this.onPurchaseImage);this.removeEventListener('change',this.onPickerChange);this.scope?.removeEventListener('change',this.onOfferChange);this.ready=false;}
  async hydrateVariantGallery(variant,request){
    const gallery=this.scope.querySelector('media-gallery');
    const sectionId=this.scope.id?.replace(/^shopify-section-/,'');
    if(!gallery||!sectionId)return;
    const controller=new AbortController();this.galleryRequest=controller;
    const timer=setTimeout(()=>controller.abort(),15000);
    gallery.setAttribute('aria-busy','true');this.dataset.galleryStatus='loading';
    try{
      // Native hide_variants omits other-colour slides. Fetch the same native section for the chosen variant.
      const isProductPage=this.dataset.productPage!=='false';
      const url=isProductPage?new URL(location.href):new URL((window.Shopify?.routes?.root||'/')+'products/'+this.product.handle,location.origin);
      url.searchParams.set('variant',variant.id);
      // Homepage product resources need the product route to resolve the selected native gallery.
      if(isProductPage)url.searchParams.set('section_id',sectionId);
      const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw Error('Native gallery unavailable');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=html.querySelector('media-gallery');
      if(!next?.querySelector('[slide-id="'+variant.featured_media.id+'"],[data-media-id="'+variant.featured_media.id+'"]'))throw Error('Selected native media unavailable');
      if(request!==this.galleryRequestNumber||!this.isConnected)return;
      const galleryHtml=document.implementation.createHTMLDocument('');galleryHtml.body.append(next);
      // Refresh only the native gallery: another bundle item's image must not replace main price or choices.
      this.dispatchEvent(new VariantUpdateEvent(variant,this.id,{html:galleryHtml,productId:String(this.product.id)}));
      await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
      if(request!==this.galleryRequestNumber||!this.isConnected)return;
      const current=this.scope.querySelector('media-gallery');
      document.dispatchEvent(new CustomEvent('purchase:image-update',{detail:{gallery:current,mediaId:variant.featured_media.id,hydrated:true}}));
      this.dataset.galleryStatus='ready';
    }catch(error){if(request===this.galleryRequestNumber){this.dataset.galleryStatus='failed';this.dispatchEvent(new CustomEvent('kellermont:gallery-error',{bubbles:true,detail:{variantId:variant.id}}));}}
    finally{clearTimeout(timer);if(request===this.galleryRequestNumber)this.scope.querySelector('media-gallery')?.removeAttribute('aria-busy');}
  }
  selectedValues(){return this.product.options.map((_,i)=>this.inputs.find(input=>Number(input.dataset.optionIndex)===i&&input.checked)?.value);}
  syncFromOffer(updateUrl=true,changedRow=null){
    const offer=this.scope.querySelector('kellermont-offer');
    const tier=offer?.active || offer?.querySelector('[data-offer-tier]:has(input[type=radio]:checked)');
    const row=changedRow||tier?.querySelector('[data-variant-row]');
    if(!row)return;
    const values=[...row.querySelectorAll('select[data-option-index]')].map(s=>s.value);
    for(const input of this.inputs)input.checked=input.value===values[Number(input.dataset.optionIndex)];
    this.updateDisplay(selectedVariant(this.product,values),updateUrl,false);
  }
  updateDisplay(variant,updateUrl,updateGallery){
    const values=this.selectedValues();
    for(const fieldset of this.querySelectorAll('[data-option-fieldset]'))fieldset.querySelector('[data-selected-value]').textContent=values[Number(fieldset.dataset.optionFieldset)]||'';
    for(const input of this.inputs){const candidate=[...values];candidate[Number(input.dataset.optionIndex)]=input.value;const available=!!selectedVariant(this.product,candidate)?.available;input.setAttribute('aria-disabled',String(!available));}
    this.querySelector('[data-selected-variant]').value=variant?.id||'';
    this.dataset.selectedVariantId=variant?.id||'';
    const status=this.querySelector('[data-selector-status]');status.hidden=!!variant?.available;status.textContent=variant?.available?'':this.dataset.unavailable;
    if(!variant)return;
    const formatted=this.prices[variant.id];
    if(formatted)for(const price of this.scope.querySelectorAll(`product-price[data-product-id="${this.product.id}"]`)){
      const sale=price.querySelector('[ref="priceContainer"] .price'),compare=price.querySelector('.compare-at-price');
      if(sale)sale.textContent=formatted.price;
      if(compare){compare.textContent=formatted.compare;const group=compare.closest('[role="group"]')||compare;group.hidden=Number(variant.compare_at_price)<=Number(variant.price);}
    }
    if(updateUrl&&this.dataset.productPage!=='false'){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(history.state,'',url);}
    const gallery=this.scope.querySelector('media-gallery');
    if(updateGallery&&gallery&&variant.featured_media?.id)document.dispatchEvent(new CustomEvent('purchase:image-update',{detail:{gallery,mediaId:variant.featured_media.id}}));
  }
}
if(!customElements.get('kellermont-variant-selects'))customElements.define('kellermont-variant-selects',KellermontVariantSelects);
